// eslint-disable-next-line import/prefer-default-export
export const heroRecommendationSelector = state => state.heroRecommendation.get('heroRecommendation');
export const heroRecommendationIsLoadingSelector = state => state.heroRecommendation.get('isLoading');
